import { MapfreIconComponent } from '../../individual-components/mapfre-icon/mapfre-icon.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreIconComponent],
  selector: 'mapfre-info-divs',
  templateUrl: './mapfre-info-divs.component.html'
})
export class MapfreInfoDivsComponent {
  @Input() additionalClasses = 'default';
  @Input() iconClasses = 'fas fa-info-circle alert-icon icon-default'
  @Input() type = 'icon';
  @Input() additionDivClass:  string;
  

}
